import { createFileRoute } from "@tanstack/react-router";
import { ClientOnly } from "@/components/ClientOnly";
import { PageLoader } from "@/components/PageLoader";
import PageGate from "@/components/auth/PageGate";
import GamePlay from "@/pages/GamePlay";

export const Route = createFileRoute("/_app/games/$slug/play")({
  component: () => (
    <PageGate pageKey="games"><ClientOnly fallback={<PageLoader />}><GamePlay /></ClientOnly></PageGate>
  ),
});
